<template>
  <div>
    <StepperHeaderComponent />
    <v-alert
      border="top"
      color="#15314e"
      :value="getServiceAchDown"
      dark
      icon="mdi-alert"
      transition="scroll-y-transition"
      dismissible
      style="font-size: 20px; color: #ff8400"
    >
      ¡Ups! ocurrió un error en la transacción
    </v-alert>
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
      style="background: blue"
    >
      <v-card color="#ff8400">
        <v-card-text style="color: white">
          Espere un momento por favor...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card class="mb-12" elevation="0">
      <v-row justify="center">
        <v-col lg="9" v-if="!getServiceAchDown">
          <v-card elevation="1" class="pl-2 pt-4">
            <h3 class="ml-2" style="color: #1a4594">
              Resumen de la transacción
            </h3>
            <div class="text-center">
              <v-row justify="center" class="mt-7">
                <v-avatar
                  v-if="testDataFinal.status == 'APPROVED'"
                  size="140"
                  style="border: 5px solid #1c712e"
                >
                  <v-icon style="font-size: 50px" color="#1c712e">
                    mdi-check-bold
                  </v-icon>
                </v-avatar>
                <v-avatar
                  v-if="
                    testDataFinal.status == 'DECLINED' ||
                    testDataFinal.status == 'ERROR'
                  "
                  size="140"
                  style="border: 5px solid red"
                >
                  <v-icon style="font-size: 50px" color="red">
                    mdi-close-octagon
                  </v-icon>
                </v-avatar>
              </v-row>
              <v-row justify="center">
                <label class="mt-6">{{ testDataFinal.description }}</label>
              </v-row>
              <v-row justify="center">
                <h2 style="color: #1a4594">
                  COP
                  {{
                    payWithAchPse
                      ? getBalanceFormatCOP(testDataFinal.amountInCents)
                      : getBalanceFormatCOP(testDataFinal.amountInCents / 100)
                  }}
                </h2>
              </v-row>
              <v-row>
                <v-card class="mx-auto" max-width="370px" elevation="0">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead style="background: #fbfbfb">
                        <tr>
                          <th class="text-left"></th>
                          <th class="text-left" style="color: #1a4594">
                            Información de la transacción
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-right" style="font-size: 11px">
                            Transacción #
                          </td>
                          <td class="text-left" style="font-size: 11px">
                            {{ testDataFinal.id }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right" style="font-size: 11px">
                            Referencia
                          </td>
                          <td class="text-left" style="font-size: 11px">
                            {{ testDataFinal.reference }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-row>
              <br />
              <v-divider></v-divider>
              <br />
              <label class="mt-6">PAGO EFECTUADO CON</label>
              <v-row justify="center">
                <v-avatar size="160" class="mt-4 profile" tile>
                  <!-- <v-img
                    :src="
                      require('/src/assets/logo' +
                        getResponse.payment_method_type.slice(
                          0,
                          getResponse.payment_method_type.indexOf('_')
                        ) +
                        '.png')
                    "
                  ></v-img> -->

                  <v-img
                    class="mx-auto"
                    :src="
                      testDataFinal.paymentMethod == 'NEQUI'
                        ? require('/src/assets/logoNequiRespuesta.png')
                        : testDataFinal.paymentMethod == 'BANCOLOMBIA_TRANSFER'
                        ? require('/src/assets/logoBANCOLOMBIA.png')
                        : testDataFinal.paymentMethod == 'PSE'
                        ? require('/src/assets/logoPSE.png')
                        : '#'
                    "
                  ></v-img>
                </v-avatar>
              </v-row>
              <v-row justify="center" class="mt-6">
                <h3 style="color: #1a4594">
                  COMPROBANTE DE PAGO
                  {{ testDataFinal.paymentMethodName }}
                </h3>
              </v-row>
              <v-row class="mt-8">
                <v-card class="mx-auto" max-width="370px" elevation="0">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="text-right" style="font-size: 11px">
                            Estado de la transacción:
                          </td>
                          <td class="text-left" style="font-size: 11px">
                            {{ testDataFinal.statusName }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            testDataFinal.paymentMethod ==
                            'BANCOLOMBIA_TRANSFER'
                          "
                        >
                          <td class="text-right" style="font-size: 11px">
                            Descripción del pago:
                          </td>
                          <td class="text-left" style="font-size: 11px">
                            {{ testDataFinal.description }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right" style="font-size: 11px">
                            Pago efectuado a:
                          </td>
                          <td class="text-left" style="font-size: 11px">
                            {{ testDataFinal.merchantName }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right" style="font-size: 11px">
                            Fecha de la transacción:
                          </td>
                          <td class="text-left" style="font-size: 11px">
                            {{ testDataFinal.createdAt }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right" style="font-size: 11px">
                            Ticked ID:
                          </td>
                          <td class="text-left" style="font-size: 11px">
                            {{ testDataFinal.id }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-row>
              <v-row justify="center">
                <v-col lg="12">
                  <v-row aling="center" justify="center">
                    <v-col lg="4">
                      <v-btn color="primary" @click="print"
                        ><v-icon>mdi-cloud-print-outline</v-icon> Imprimir
                        comprobante
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row aling="center" justify="center">
                    <v-col lg="5">
                      <v-btn color="primary" @click="goToHome"
                        ><v-icon>mdi-arrow-left</v-icon> Pagar otras facturas
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row aling="center" justify="center">
                    <v-col lg="5">
                      <v-btn
                        href="https://dialnet.net/noticias/"
                        color="primary"
                        ><v-icon>mdi-newspaper-variant-multiple-outline</v-icon>
                        Ir a noticias
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col v-else>
          <v-alert border="right" colored-border type="error" elevation="2">
            En estos momentos no podemos mostrarte el estado final de la
            transacción, vuelva a intentar pronto
          </v-alert>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import StepperHeaderComponent from "../../components/layout/StepperHeaderComponent.vue";
import axios from "axios";
export default {
  name: "ListInvoice",
  components: {
    StepperHeaderComponent,
  },
  async mounted() {
    // console.log("actualizado");

    this.$store.commit("moduleStepper/setStepperPage", 4);
    await this.getResponsePay();
    // console.log("this.testresponse is", this.testResponse);
    if (Object.keys(this.testResponse).length === 0) {
      // console.log("la factura no existe ni en wompi ni ach, o ya fue pagada");
      window.location.href = `${process.env.VUE_APP_URL_ACCESS_INDEX}buscar`;
      return;
    }

    this.setTestDataFinal();
    this.dialog = false;
    // const item = localStorage.getItem("sendToPaymentNodum")
    localStorage.clear();
    // localStorage.setItem("sendToPaymentNodum", item);
  },
  created() {},
  computed: {
    getServiceAchDown: {
      get() {
        const value = this.$store.getters["moduleAch/getServiceAchDown"];

        this.dialog = !value;

        return value;
      },
      set(value) {
        this.$store.commit("moduleAch/setServiceAchDown", value);
      },
    },
  },
  data() {
    return {
      // sendToPaymentNodum: false,
      payWithAchPse: false,
      dialog: true,
      testResponse: {},
      testDataFinal: {
        amountInCents: 0,
        status: "",
        statusName: "",
        id: "",
        reference: "",
        paymentMethod: "",
        paymentMethodName: "",
        description: "",
        merchantName: "",
        createdAt: "",
        cus: "",
      },
      getResponse: {},
      publicKey: process.env.VUE_APP_WOMPI_ACCESS_PUBLIC_KEY,
      baseUrl: process.env.VUE_APP_WOMPI_BASE_URL,
      formMethodPayment: "BANCOLOMBIA",
      info: [
        {
          name: "Transacción #",
          calories: "111913-1626472298-14347",
        },
        {
          name: "Referencia",
          calories: "test_91xDbb_1627181653202_2zor24qvepy",
        },
      ],
      transaction: [
        { name: "Estado de la transacción:", value: "Aprobada" },
        { name: "Descripción del pago:", value: "Alguna descripción" },

        {
          name: "Pago efectuado a:",
          value:
            "DIALNET DE COLOMBIA S.A E.S.P. - (DIALNET DE COLOMBIA S.A E.S.P. NIT 819003851-6)",
        },
        { name: "Fecha de la transacción:", value: "2021-07-25" },
        {
          name: "Código Único de Seguimiento (CUS):",
          value: "SANBOX-2RUNMUYJ2a-OK",
        },
        { name: "Ticked ID:", value: "111913162722920216244" },
      ],
      statusResponses: {
        APPROVED: {
          name: "APPROVED",
          response: "APROBADA",
          info: "PAGASTE",
        },
        DECLINED: {
          name: "DECLINED",
          response: "DECLINADA",
          info: "DECLINASTE",
        },
        PENDING: {
          name: "PENDING",
          response: "PENDIENTE",
          info: "PENDIENTE",
        },
        ERROR: {
          name: "ERROR",
          response: "ERRADA",
          info: "HUBO UN ERROR",
        },
        OK: {
          name: "OK",
          response: "APROBADA",
          info: "PAGASTE",
        },
        NOT_AUTHORIZED: {
          name: "NOT_AUTHORIZED",
          response: "NO AUTORIZADA",
          info: "NO AUTORIZADA",
        },
        FAILED: {
          name: "FAILED",
          response: "FALLIDA",
          info: "HUBO UN ERROR",
        },
      },
      paymentMethod: {
        NEQUI: {
          name: "NEQUI",
          response: "NEQUI",
        },
        BANCOLOMBIA_TRANSFER: {
          name: "BANCOLOMBIA_TRANSFER",
          response: "BANCOLOMBIA",
        },
      },
    };
  },
  methods: {
    goToHome() {
      this.$router.push("/");
    },
    getResponseStatus(status) {
      // console.log("getResponseStatus", status);
      return this.statusResponses[status].response;
    },
    getPaymentMethod(paymentMethod) {
      // console.log("getPaymentMethod", paymentMethod);
      return this.paymentMethod[paymentMethod].response;
    },
    setTestDataFinal() {
      let data = this.testResponse;
      // consolek.log("voy a setear los datos con la data", data);
      if (this.payWithAchPse) {
        // localStorage.setItem("sendToPaymentNodum", true);
        // this.sendToPaymentNodum = true;
        const dateTransaction = new Date(data["SolicitedDate"][0]);
        const currentDate = new Date();
        const diffTime = Math.abs(dateTransaction - currentDate);
        const diffMinutes = Math.ceil(diffTime / (1000 * 60));
        const maxMinutesForViewTransaction = 20;
        // console.log("La diferencia de minutos es", diffMinutes);
        if (diffMinutes > maxMinutesForViewTransaction) {
          // console.log(
          //   "Han pasado más de ${maxMinutesForViewTransaction} minutos"
          // );
          window.location.href = `${process.env.VUE_APP_URL_ACCESS_INDEX}buscar`;
        } else {
          this.testDataFinal.id = data["TrazabilityCode"][0];
          this.testDataFinal.status = data["State"][0];
          this.testDataFinal.statusName = this.getResponseStatus(
            data["State"][0]
          );
          // console.log("entro acá");

          this.testDataFinal.reference = data["PaymentID"][0];
          this.testDataFinal.paymentMethod = "PSE";
          this.testDataFinal.paymentMethodName = "PSE";

          this.testDataFinal.merchantName = "DIALNET DE COLOMBIA S.A. E.S.P.";
          this.testDataFinal.createdAt = data["SolicitedDate"][0];
          this.testDataFinal.description = "Pago de factura";
          this.testDataFinal.amountInCents = data["Amount"][0];
        }
      } else {
        this.testDataFinal.id = data.data.id;
        // console.log("entre aquí", data.data.status);
        this.testDataFinal.status = data.data.status;
        this.testDataFinal.statusName = this.getResponseStatus(
          data.data.status
        );

        this.testDataFinal.reference = data.data.reference;
        this.testDataFinal.paymentMethod = data.data.payment_method_type;
        this.testDataFinal.paymentMethodName = this.getPaymentMethod(
          data.data.payment_method_type
        );

        this.testDataFinal.merchantName = data.data.merchant.legal_name;
        this.testDataFinal.createdAt = data.data.created_at;
        this.testDataFinal.description = data.data.status_message;
        this.testDataFinal.amountInCents = data.data.amount_in_cents;
      }
    },
    getBalanceFormatCOP(balance) {
      const formatterPeso = new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 2,
      });
      return formatterPeso.format(balance);
    },
    async getResponsePayFromAchPSE() {
      // localStorage.setItem("sendToPaymentNodum", true);
      let id = this.$route.query.id ? this.$route.query.id : "";
      if (id != "") {
        // console.log("Traigo un id por el query y es: " + id);

        await this.$store.dispatch("moduleAch/getTransaction", id);
        const stateTransaction = await this.$store.getters[
          "moduleAch/getStatus"
        ];
        if (stateTransaction != "null") {
          //if no hubo un error en la petición
          const transaction = await this.$store.getters[
            "moduleAch/getTransaction"
          ];
          // console.log("transaccion: ", transaction);
          if (
            transaction["Amount"][0] == "0" &&
            transaction["BankCode"][0] == "" &&
            transaction["BankName"][0] == ""
          ) {
            return {};
          }
          // const stateTransaction = await this.$store.dispatch("moduleAch/getTransaction", id);
          if (stateTransaction && stateTransaction != "null") {
            if (stateTransaction == "OK") {
              let stateToSend = "APPROVED";
              // console.log(
              //   "La transacción tiene como estado OK, entonces debo enviar a que se paguen las facturas en Nodum"
              // );
              await this.$store.dispatch("moduleAch/getInvoices", id);
              await this.$store.dispatch("moduleAch/sendToPay", stateToSend);

              // window.location ="/buscar"
            } else if (stateTransaction == "NOT_AUTHORIZED") {
              let stateToSend = "DECLINED";

              await this.$store.dispatch("moduleAch/getInvoices", id);
              await this.$store.dispatch("moduleAch/sendToPay", stateToSend);

              // window.location ="/buscar"
            } else if (stateTransaction == "FAILED") {
              let stateToSend = "ERROR";

              await this.$store.dispatch("moduleAch/getInvoices", id);
              await this.$store.dispatch("moduleAch/sendToPay", stateToSend);
            } else {
              // console.log(
              //   "La transacción tiene un estado distinto a OK (approved), entonces se manda ese estado a las facturas en Nodum"
              // );
              await this.$store.dispatch("moduleAch/getInvoices", id);
              await this.$store.dispatch(
                "moduleAch/sendToPay",
                stateTransaction
              );

              // window.location ="/buscar"
            }
          }
          // console.clear();
          // console.log("Id a buscar", this.$route.query.id);

          return transaction;
        }
      }
      G;
    },
    async getResponsePay() {
      /** Configurar para que también reciba el paymentId de las transacciones de pse
       *  pueda saber diferenciar entre las de wompi y las de ach
       *  Y finalmente se pueda mostrar la info correspondiente
       */
      let url = this.baseUrl + "transactions/" + this.$route.query.id;
      let config = {
        headers: {
          Authorization: "Bearer " + this.publicKey,
        },
      };
      try {
        let response = await axios.get(url, config);
        this.testResponse = response.data;
      } catch (error) {
        /** Si entra al catch fue porque no encuentra la referencia en wompi, entonces buscamos en ach */
        //  console.log("hola--->",localStorage.getItem("sendToPaymentNodum"))
        // if (localStorage.getItem("sendToPaymentNodum") != "true") {
        //si no se ha mandado a enviar el estado a nodum
        // console.log("si");
        const res = await this.getResponsePayFromAchPSE();

        // console.clear();
        // console.log("mi response es: ", res);
        if (res == []) {
          // this.testResponse = []
          console.log("");
          // console.log("No se encuentra como pago de wompi ni de ach");
        } else {
          this.payWithAchPse = true;
          this.testResponse = res;
        }
        // }

        // console.log("error", error);
      }
      // const response = await axios.get(url, config);
      // // console.log(response);
      // this.testResponse = response.data.data;
    },
    print() {
      window.print();
    },
  },
};
</script>
